var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[(_vm.isWeixin)?_c('img',{staticClass:"tip",attrs:{"src":_vm.aliURL + '/h5/purchase/img/new/go-other.png'}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }